import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import fr from "vuetify/es5/locale/fr";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#102a43",
        secondary: "#e0fcff",
        tertiary: "#e0e8f9",
        accent: "#E0E8F9",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        light_grey: "#b2b9be",
        grey_1: "#FAFEFE",
        grey_6: "#627D98",
        grey_7: "#486581",
        grey_8: "#334E68",
        medium_grey: "#334E68",
        dark_grey: "#243B53",
        darker_grey: "#102a43",
        grey_10: "#102A43",
        blue_0: "F9FEFF",
        greekblue_0: "F9FAFE",
        light_blue: "#e0fcff",
        medium_blue: "#62d4d2",
        dark_blue: "#044e54",
        greekblue_1: "#E0E8F9",
        greekblue_6: "4C63B6",
        greekblue_10: "#19216C",
        blue_1: "#E0FCFF",
        blue_6: "#2CB1BC",
        blue_8: "#0E7C86",
        blue_9: "#2d3a8c",
        blue_10: "#044E54",
        light_purple: "#e0e8f9",
        medium_purple: "#2d3a8c",
        dark_purple: "#19216c",
        green_10: "#05400A"
      }
    }
  },
  lang: {
    locales: { fr },
    current: "fr"
  }
});
